import { useUserPipelines } from '@common/pipeline/hooks/useUserPipelines';

import { PipelineTable } from './pipeline-list';

export function UserPipelines() {
  const { data, isLoading } = useUserPipelines();

  return <PipelineTable isLoading={isLoading} data={data?.User} />;
}
